import { firestore } from '../firebase/firebase';

export const initializeFeaturedOrder = async () => {
  try {
    const musicRef = firestore.collection('music');
    const featuredSnapshot = await musicRef.where('featured', '==', true).get();
    
    const batch = firestore.batch();
    
    featuredSnapshot.docs.forEach((doc, index) => {
      const data = doc.data();
      // Only update if featuredOrder is not already set
      if (data.featuredOrder === undefined || data.featuredOrder === null) {
        batch.update(doc.ref, { featuredOrder: index });
      }
    });
    
    await batch.commit();
    console.log('Featured order initialized successfully');
  } catch (error) {
    console.error('Error initializing featured order:', error);
  }
};